import { Style } from '@/components/style';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ReactComponent as Search } from '@/assets/img/fe_search.svg';
import { cloneDeep, forEach, head, last } from 'lodash';
import OrderServeType from '@/constants/OrderServeType';
import PropTypes from 'prop-types';
import * as WelcomeAction from '@actions/welcome/welcomeAction';
import WelcomeCTAUtils from '@/components/customizeWelcome/components/welcomeCTA/utils/welcomeCTAUtils';
import { setWelcomeIsCustomerPhoneValid } from '@/actions/customizeWelcome/customizeWelcomeAction';

const {
  alertColor,
  blackColor,
  primaryColor,
  gray3Color,
  backgroundColor,
  secondaryColor,
} = new Style().getUiConfig();

const style = new Style();

type Params = { storeUuid: string };

function ExistingOrderBtnWelcome({ webStoreVo, orderVo, selectedServeType }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { storeUuid } = useParams<Params>();
  const lineInfo = useSelector<RootStateOrAny, any>(
    (state) => state.lineReducer.lineProfile
  );
  const webStoreVoResponse = useSelector(
    (state: RootStateOrAny) => state.welcomeReducer.webStoreVoResponse
  );
  const customizeWelcomeReducer = useSelector(
    (state: RootStateOrAny) => state.customizeWelcomeReducer
  );

  const getWebVo = () => {
    const webVo = cloneDeep(webStoreVoResponse.data);

    webVo.lineInfoVo = {
      userId: lineInfo?.userId || null,
    };

    return webVo;
  };

  const setFormInputValidStatus = (isValidFormatData: any) => {
    const { isPhoneValid } = isValidFormatData;

    dispatch(setWelcomeIsCustomerPhoneValid(isPhoneValid));
  };

  const validateOrder = async () => {
    const isValidFormatData = await WelcomeCTAUtils.checkWelcomeCTAValid(
      webStoreVo,
      orderVo,
      customizeWelcomeReducer
    );
    setFormInputValidStatus(isValidFormatData);
    let isValid = true;

    if (!isValidFormatData['isPhoneValid']) isValid = false;

    return isValid;
  };

  const submitExistingOrder = async () => {
    const isValid = await validateOrder();

    if (!isValid) return;
    const newOrderVo = WelcomeCTAUtils.updateExistingOrderInfoToOrderVo(
      webStoreVo,
      orderVo,
      customizeWelcomeReducer
    );

    const webVo = getWebVo();
    webVo.orderVo = newOrderVo;

    WelcomeAction.post(storeUuid, webVo).then((res: any) => {
      history.push(`${process.env.REACT_APP_VERSION}${res.data.route}`);
    });
  };
  return (
    <div>
      {webStoreVo?.isPostPayEnable &&
        selectedServeType === OrderServeType.DINE_IN && (
          <div
            className="d-flex justify-content-center"
            style={{ marginBottom: '10px' }}
          >
            <div
              role="presentation"
              className="btn-group"
              style={{ width: '100%' }}
              onClick={() => {
                submitExistingOrder();
              }}
            >
              <div
                className="btn btn-lg"
                style={style.primaryBtnSelected()}
                data-testid="welcome_existingOrder"
              >
                <FormattedMessage id="welcome.existingOrder" />
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

ExistingOrderBtnWelcome.defaultProps = {};

ExistingOrderBtnWelcome.propTypes = {
  webStoreVo: PropTypes.shape({
    supplierWebsite: PropTypes.string,
    supplierName: PropTypes.string,
    displayName: PropTypes.string,
    isPostPayEnable: PropTypes.bool,
  }).isRequired,
  orderVo: PropTypes.shape({}).isRequired,
  selectedServeType: PropTypes.string.isRequired,
};

export default ExistingOrderBtnWelcome;
